import { createContext, useContext, useEffect, useState } from 'react';

const FLUID_QUERY = '(max-width: 1023px)';

const FluidLayoutContext = createContext(false);

export function useFluidLayout() {
  return useContext(FluidLayoutContext);
}

export function FluidLayoutProvider({ disabled = false, children }) {
  const [narrow, setNarrow] = useState(
    () => window.matchMedia?.(FLUID_QUERY).matches ?? false,
  );

  useEffect(() => {
    const query = window.matchMedia?.(FLUID_QUERY);
    if (!query) return undefined;

    const sync = () => setNarrow(query.matches);
    sync();
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, []);

  return (
    <FluidLayoutContext.Provider value={narrow && !disabled}>
      {children}
    </FluidLayoutContext.Provider>
  );
}
